import { render, staticRenderFns } from "./productTab.vue?vue&type=template&id=2fe0c6aa&scoped=true&"
import script from "./productTab.vue?vue&type=script&lang=js&"
export * from "./productTab.vue?vue&type=script&lang=js&"
import style0 from "./productTab.vue?vue&type=style&index=0&id=2fe0c6aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe0c6aa",
  null
  
)

export default component.exports